import DataDisplayRowI from "../DataDisplayRowI";
import getGamesRow from "../DataDisplayRow/GamesRow";
import DataDisplayTable from "../DataDisplayTable";

class GamesTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getGamesRow()
    }
}

let gamesTable: GamesTable | null = null;

export default function getGamesTable(): GamesTable {
    if (gamesTable === null)
        gamesTable = new GamesTable()
    return gamesTable
}